<template>
  <div class="card p-1 mb-2">
    <div class="card-body">
      <h4 class="font-serif mb-3">
        📢 {{ $t("dashboard.companyData.invite_a_friend") }}
      </h4>
      <p>{{ $t("dashboard.companyData.invite_a_friend_message") }}</p>
      <button @click="copyReferralLink" class="btn btn-subtle-primary">
        <font-awesome-icon icon="fa-copy" class="me-1" />
        {{ $t("dashboard.companyData.click_to_copy_link") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalHandlers } from "@/composables/useGlobalHandlers";
import { copyToClipboard } from "@/utils/copyUtils";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  companyId: number;
}>();

const { t } = useI18n();
const { globalSuccessHandler, globalErrorHandler } = useGlobalHandlers();

const copyReferralLink = async () => {
  const referralLink = `https://www.soldera.org/?referrer_id=${props.companyId}&utm_source=referral1&utm_medium=dashboard&utm_campaign=referral1`;

  await copyToClipboard(
    referralLink,
    t("dashboard.companyData.link_copied"),
    globalSuccessHandler,
    globalErrorHandler,
    t("dashboard.companyData.link_copied_fallback"),
    t("dashboard.companyData.link_copy_failed")
  );
};
</script>
